@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_798_634_079)
internal val Res.string.lesson_ripasso_genere_numero_title: StringResource by lazy {
      StringResource("string:lesson_ripasso_genere_numero_title", "lesson_ripasso_genere_numero_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188540, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185964, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187283, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178608, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174652, 70),
      ))
    }

@delegate:ResourceContentHash(-1_443_028_262)
internal val Res.string.lesson_royal_names_desc: StringResource by lazy {
      StringResource("string:lesson_royal_names_desc", "lesson_royal_names_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188619, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186039, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187358, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178679, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174723, 115),
      ))
    }

@delegate:ResourceContentHash(-1_901_257_172)
internal val Res.string.lesson_royal_names_full_desc: StringResource by lazy {
      StringResource("string:lesson_royal_names_full_desc", "lesson_royal_names_full_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188767, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186167, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187482, 100),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178795, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174839, 100),
      ))
    }

@delegate:ResourceContentHash(1_068_894_647)
internal val Res.string.lesson_royal_names_full_title: StringResource by lazy {
      StringResource("string:lesson_royal_names_full_title", "lesson_royal_names_full_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188884, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186276, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187583, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178896, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174940, 53),
      ))
    }

@delegate:ResourceContentHash(-467_071_709)
internal val Res.string.lesson_royal_names_title: StringResource by lazy {
      StringResource("string:lesson_royal_names_title", "lesson_royal_names_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188946, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186334, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187637, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178950, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174994, 60),
      ))
    }

@delegate:ResourceContentHash(1_213_647_913)
internal val Res.string.lesson_scorta_di_aggettivi_desc: StringResource by lazy {
      StringResource("string:lesson_scorta_di_aggettivi_desc", "lesson_scorta_di_aggettivi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189011, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186399, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187702, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179011, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175055, 75),
      ))
    }

@delegate:ResourceContentHash(689_550_520)
internal val Res.string.lesson_scorta_di_aggettivi_title: StringResource by lazy {
      StringResource("string:lesson_scorta_di_aggettivi_title", "lesson_scorta_di_aggettivi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189087, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186483, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187790, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179095, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175131, 76),
      ))
    }

@delegate:ResourceContentHash(-1_243_012_956)
internal val Res.string.lesson_sdm_f_congiuntivo_desc: StringResource by lazy {
      StringResource("string:lesson_sdm_f_congiuntivo_desc", "lesson_sdm_f_congiuntivo_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189148, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186552, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187859, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179164, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175208, 85),
      ))
    }

@delegate:ResourceContentHash(-985_026_623)
internal val Res.string.lesson_sdm_f_congiuntivo_title: StringResource by lazy {
      StringResource("string:lesson_sdm_f_congiuntivo_title", "lesson_sdm_f_congiuntivo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189250, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186642, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187953, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179246, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175294, 50),
      ))
    }

@delegate:ResourceContentHash(-1_383_721_830)
internal val Res.string.lesson_sdm_f_intro_desc: StringResource by lazy {
      StringResource("string:lesson_sdm_f_intro_desc", "lesson_sdm_f_intro_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189309, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186693, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188012, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179297, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175345, 87),
      ))
    }

@delegate:ResourceContentHash(-196_410_059)
internal val Res.string.lesson_sdm_f_intro_title: StringResource by lazy {
      StringResource("string:lesson_sdm_f_intro_title", "lesson_sdm_f_intro_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189409, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186781, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188108, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179381, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175433, 64),
      ))
    }

@delegate:ResourceContentHash(-778_890_159)
internal val Res.string.lesson_segni_degli_aggettivi_desc: StringResource by lazy {
      StringResource("string:lesson_segni_degli_aggettivi_desc", "lesson_segni_degli_aggettivi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189474, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186846, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188173, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179446, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175498, 97),
      ))
    }

@delegate:ResourceContentHash(-550_488_099)
internal val Res.string.lesson_segni_degli_aggettivi_title: StringResource by lazy {
      StringResource("string:lesson_segni_degli_aggettivi_title", "lesson_segni_degli_aggettivi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189588, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 186960, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188283, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179552, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175596, 70),
      ))
    }

@delegate:ResourceContentHash(1_579_412_054)
internal val Res.string.lesson_segni_vari_desc: StringResource by lazy {
      StringResource("string:lesson_segni_vari_desc", "lesson_segni_vari_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189663, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187039, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188366, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179627, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175667, 78),
      ))
    }

@delegate:ResourceContentHash(-609_528_222)
internal val Res.string.lesson_segni_vari_title: StringResource by lazy {
      StringResource("string:lesson_segni_vari_title", "lesson_segni_vari_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189766, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187130, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188461, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179730, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175746, 51),
      ))
    }

@delegate:ResourceContentHash(492_515_288)
internal val Res.string.lesson_significato_dei_nomi_desc: StringResource by lazy {
      StringResource("string:lesson_significato_dei_nomi_desc", "lesson_significato_dei_nomi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189826, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187182, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188513, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179778, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175798, 112),
      ))
    }

@delegate:ResourceContentHash(775_451_494)
internal val Res.string.lesson_significato_dei_nomi_title: StringResource by lazy {
      StringResource("string:lesson_significato_dei_nomi_title", "lesson_significato_dei_nomi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 189951, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187299, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188634, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179891, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175911, 69),
      ))
    }

@delegate:ResourceContentHash(619_352_766)
internal val Res.string.lesson_soggetto_esplicito_desc: StringResource by lazy {
      StringResource("string:lesson_soggetto_esplicito_desc", "lesson_soggetto_esplicito_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190025, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187381, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188700, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 179965, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175981, 90),
      ))
    }

@delegate:ResourceContentHash(337_206_802)
internal val Res.string.lesson_soggetto_esplicito_title: StringResource by lazy {
      StringResource("string:lesson_soggetto_esplicito_title", "lesson_soggetto_esplicito_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190124, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187496, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188787, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180068, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176072, 67),
      ))
    }

@delegate:ResourceContentHash(687_097_255)
internal val Res.string.lesson_stars_earned_desc: StringResource by lazy {
      StringResource("string:lesson_stars_earned_desc", "lesson_stars_earned_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190192, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187564, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188851, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180136, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176140, 56),
      ))
    }

@delegate:ResourceContentHash(-2_045_304_387)
internal val Res.string.lesson_torniamo_alla_grammatica_desc: StringResource by lazy {
      StringResource("string:lesson_torniamo_alla_grammatica_desc", "lesson_torniamo_alla_grammatica_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190253, 136),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187629, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 188916, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180197, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176197, 128),
      ))
    }

@delegate:ResourceContentHash(1_372_282_742)
internal val Res.string.lesson_torniamo_alla_grammatica_title: StringResource by lazy {
      StringResource("string:lesson_torniamo_alla_grammatica_title", "lesson_torniamo_alla_grammatica_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190390, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187758, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189045, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180322, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176326, 65),
      ))
    }

@delegate:ResourceContentHash(2_126_605_332)
internal val Res.string.lesson_traduciamo_i_nomi_desc: StringResource by lazy {
      StringResource("string:lesson_traduciamo_i_nomi_desc", "lesson_traduciamo_i_nomi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190464, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187836, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189123, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180400, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176392, 77),
      ))
    }

@delegate:ResourceContentHash(1_662_744_138)
internal val Res.string.lesson_traduciamo_i_nomi_title: StringResource by lazy {
      StringResource("string:lesson_traduciamo_i_nomi_title", "lesson_traduciamo_i_nomi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190558, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187922, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189209, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180478, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176470, 74),
      ))
    }

@delegate:ResourceContentHash(-1_629_552_072)
internal val Res.string.lesson_transliteration_reading_desc: StringResource by lazy {
      StringResource("string:lesson_transliteration_reading_desc", "lesson_transliteration_reading_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190633, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187997, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189276, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180541, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176545, 119),
      ))
    }

@delegate:ResourceContentHash(1_121_335_595)
internal val Res.string.lesson_transliteration_reading_title: StringResource by lazy {
      StringResource("string:lesson_transliteration_reading_title", "lesson_transliteration_reading_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190753, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188121, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189404, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180657, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176665, 76),
      ))
    }

@delegate:ResourceContentHash(-2_049_899_797)
internal val Res.string.lesson_tutto_insieme_ora_desc: StringResource by lazy {
      StringResource("string:lesson_tutto_insieme_ora_desc", "lesson_tutto_insieme_ora_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190830, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188202, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189485, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180738, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176742, 89),
      ))
    }

@delegate:ResourceContentHash(-576_829_060)
internal val Res.string.lesson_tutto_insieme_ora_title: StringResource by lazy {
      StringResource("string:lesson_tutto_insieme_ora_title", "lesson_tutto_insieme_ora_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190920, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188304, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189591, 70),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180828, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176832, 62),
      ))
    }

@delegate:ResourceContentHash(-739_647_970)
internal val Res.string.lesson_un_attimo_desc: StringResource by lazy {
      StringResource("string:lesson_un_attimo_desc", "lesson_un_attimo_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 190987, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188367, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189662, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180891, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176895, 77),
      ))
    }

@delegate:ResourceContentHash(-1_471_905_511)
internal val Res.string.lesson_un_attimo_title: StringResource by lazy {
      StringResource("string:lesson_un_attimo_title", "lesson_un_attimo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191061, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188445, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189736, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 180965, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176973, 50),
      ))
    }

@delegate:ResourceContentHash(1_161_107_165)
internal val Res.string.lesson_un_seguace_eccellente_desc: StringResource by lazy {
      StringResource("string:lesson_un_seguace_eccellente_desc", "lesson_un_seguace_eccellente_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191112, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188496, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189783, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181012, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177024, 97),
      ))
    }

@delegate:ResourceContentHash(1_415_212_449)
internal val Res.string.lesson_un_seguace_eccellente_title: StringResource by lazy {
      StringResource("string:lesson_un_seguace_eccellente_title", "lesson_un_seguace_eccellente_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191206, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188598, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189889, 70),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181114, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177122, 70),
      ))
    }

@delegate:ResourceContentHash(-1_463_575_021)
internal val Res.string.lesson_una_definizione_desc: StringResource by lazy {
      StringResource("string:lesson_una_definizione_desc", "lesson_una_definizione_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191289, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188669, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 189960, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181185, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177193, 91),
      ))
    }

@delegate:ResourceContentHash(104_748_051)
internal val Res.string.lesson_una_definizione_title: StringResource by lazy {
      StringResource("string:lesson_una_definizione_title", "lesson_una_definizione_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191385, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188765, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190036, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181277, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177285, 52),
      ))
    }

@delegate:ResourceContentHash(-2_127_176_123)
internal val Res.string.lesson_uni_1_desc: StringResource by lazy {
      StringResource("string:lesson_uni_1_desc", "lesson_uni_1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191442, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188822, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190093, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181334, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177338, 121),
      ))
    }

@delegate:ResourceContentHash(-408_943_862)
internal val Res.string.lesson_uni_1_title: StringResource by lazy {
      StringResource("string:lesson_uni_1_title", "lesson_uni_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191588, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188972, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190251, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181472, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177460, 46),
      ))
    }

@delegate:ResourceContentHash(-2_127_176_123)
internal val Res.string.lesson_uni_2_desc: StringResource by lazy {
      StringResource("string:lesson_uni_2_desc", "lesson_uni_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191647, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189019, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190298, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181515, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177507, 121),
      ))
    }

@delegate:ResourceContentHash(-1_141_828_960)
internal val Res.string.lesson_uni_2_title: StringResource by lazy {
      StringResource("string:lesson_uni_2_title", "lesson_uni_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191793, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189169, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190456, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181653, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177629, 50),
      ))
    }

@delegate:ResourceContentHash(1_034_802_808)
internal val Res.string.lesson_verbi_e_participi_desc: StringResource by lazy {
      StringResource("string:lesson_verbi_e_participi_desc", "lesson_verbi_e_participi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191852, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189220, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190507, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181700, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177680, 65),
      ))
    }

@delegate:ResourceContentHash(401_152_663)
internal val Res.string.lesson_verbi_e_participi_title: StringResource by lazy {
      StringResource("string:lesson_verbi_e_participi_title", "lesson_verbi_e_participi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191926, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189290, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190569, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181758, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177746, 66),
      ))
    }

@delegate:ResourceContentHash(-1_780_489_471)
internal val Res.string.lesson_verbi_intro_1_desc: StringResource by lazy {
      StringResource("string:lesson_verbi_intro_1_desc", "lesson_verbi_intro_1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 191997, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189357, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190636, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181821, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177813, 97),
      ))
    }

@delegate:ResourceContentHash(1_122_367_472)
internal val Res.string.lesson_verbi_intro_1_title: StringResource by lazy {
      StringResource("string:lesson_verbi_intro_1_title", "lesson_verbi_intro_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192111, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189467, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190750, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181923, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177911, 70),
      ))
    }

@delegate:ResourceContentHash(1_878_128_763)
internal val Res.string.lesson_verbi_sostantivati_desc: StringResource by lazy {
      StringResource("string:lesson_verbi_sostantivati_desc", "lesson_verbi_sostantivati_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192190, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189542, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190829, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 181994, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177982, 74),
      ))
    }

@delegate:ResourceContentHash(1_329_386_233)
internal val Res.string.lesson_verbi_sostantivati_title: StringResource by lazy {
      StringResource("string:lesson_verbi_sostantivati_title", "lesson_verbi_sostantivati_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192273, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189617, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190908, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182065, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178057, 67),
      ))
    }

@delegate:ResourceContentHash(-1_547_242_107)
internal val Res.string.lesson_vocab_animals_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_animals_desc", "lesson_vocab_animals_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192345, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189685, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 190976, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182129, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178125, 93),
      ))
    }

@delegate:ResourceContentHash(1_505_896_084)
internal val Res.string.lesson_vocab_animals_title: StringResource by lazy {
      StringResource("string:lesson_vocab_animals_title", "lesson_vocab_animals_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192439, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189787, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 191086, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182223, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178219, 62),
      ))
    }

@delegate:ResourceContentHash(-2_073_593_931)
internal val Res.string.lesson_vocab_dei_sovrani_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_dei_sovrani_desc", "lesson_vocab_dei_sovrani_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192502, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189854, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 191153, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182290, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178282, 97),
      ))
    }

@delegate:ResourceContentHash(384_958_013)
internal val Res.string.lesson_vocab_dei_sovrani_title: StringResource by lazy {
      StringResource("string:lesson_vocab_dei_sovrani_title", "lesson_vocab_dei_sovrani_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192596, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 189948, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 191251, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182384, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178380, 86),
      ))
    }

@delegate:ResourceContentHash(2_000_143_769)
internal val Res.string.lesson_vocab_famiglia_societa_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_famiglia_societa_desc", "lesson_vocab_famiglia_societa_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192695, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190043, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 191350, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182467, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178467, 130),
      ))
    }

@delegate:ResourceContentHash(-640_576_976)
internal val Res.string.lesson_vocab_famiglia_societa_title: StringResource by lazy {
      StringResource("string:lesson_vocab_famiglia_societa_title", "lesson_vocab_famiglia_societa_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192850, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190186, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 191497, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182602, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178598, 83),
      ))
    }

@delegate:ResourceContentHash(1_427_477_043)
internal val Res.string.lesson_vocab_food_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_food_desc", "lesson_vocab_food_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192942, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190274, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 191589, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182690, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178682, 94),
      ))
    }

@delegate:ResourceContentHash(1_828_154_643)
internal val Res.string.lesson_vocab_food_title: StringResource by lazy {
      StringResource("string:lesson_vocab_food_title", "lesson_vocab_food_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193041, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190369, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 191696, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182777, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178777, 55),
      ))
    }

@delegate:ResourceContentHash(1_563_978_648)
internal val Res.string.lesson_vocab_humans_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_humans_desc", "lesson_vocab_humans_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193101, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190429, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 191764, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182837, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178833, 100),
      ))
    }

@delegate:ResourceContentHash(640_121_530)
internal val Res.string.lesson_vocab_humans_title: StringResource by lazy {
      StringResource("string:lesson_vocab_humans_title", "lesson_vocab_humans_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193194, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190534, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 191873, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182934, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178934, 61),
      ))
    }

@delegate:ResourceContentHash(1_271_995_754)
internal val Res.string.lesson_vocab_oggetti_sacri_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_oggetti_sacri_desc", "lesson_vocab_oggetti_sacri_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193260, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190600, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 191939, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 182996, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178996, 127),
      ))
    }

@delegate:ResourceContentHash(-1_033_014_750)
internal val Res.string.lesson_vocab_oggetti_sacri_title: StringResource by lazy {
      StringResource("string:lesson_vocab_oggetti_sacri_title", "lesson_vocab_oggetti_sacri_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193396, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190728, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192067, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183112, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179124, 92),
      ))
    }

@delegate:ResourceContentHash(-32_053_787)
internal val Res.string.lesson_vocab_pronomi_suffissi_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_pronomi_suffissi_desc", "lesson_vocab_pronomi_suffissi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193489, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190825, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192160, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183201, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179217, 90),
      ))
    }

@delegate:ResourceContentHash(151_077_984)
internal val Res.string.lesson_vocab_pronomi_suffissi_title: StringResource by lazy {
      StringResource("string:lesson_vocab_pronomi_suffissi_title", "lesson_vocab_pronomi_suffissi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193584, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190924, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192259, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183292, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179308, 63),
      ))
    }

@delegate:ResourceContentHash(-1_676_005_884)
internal val Res.string.lesson_vocab_vari_1_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_vari_1_desc", "lesson_vocab_vari_1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193648, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 190992, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192327, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183360, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179372, 64),
      ))
    }

@delegate:ResourceContentHash(1_821_586_233)
internal val Res.string.lesson_vocab_vari_1_title: StringResource by lazy {
      StringResource("string:lesson_vocab_vari_1_title", "lesson_vocab_vari_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193713, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191065, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192400, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183425, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179437, 53),
      ))
    }

@delegate:ResourceContentHash(-1_676_005_884)
internal val Res.string.lesson_vocab_vari_2_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_vari_2_desc", "lesson_vocab_vari_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193775, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191127, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192454, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183483, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179491, 64),
      ))
    }

@delegate:ResourceContentHash(-1_301_618_655)
internal val Res.string.lesson_vocab_vari_2_title: StringResource by lazy {
      StringResource("string:lesson_vocab_vari_2_title", "lesson_vocab_vari_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193840, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191200, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192527, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183548, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179556, 57),
      ))
    }

@delegate:ResourceContentHash(-1_247_264_974)
internal val Res.string.lesson_vocab_varie_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_varie_desc", "lesson_vocab_varie_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 193902, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191262, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192581, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183606, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179614, 95),
      ))
    }

@delegate:ResourceContentHash(1_567_619_341)
internal val Res.string.lesson_vocab_varie_title: StringResource by lazy {
      StringResource("string:lesson_vocab_varie_title", "lesson_vocab_varie_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194006, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191366, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192681, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183690, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179710, 52),
      ))
    }

@delegate:ResourceContentHash(-2_045_240_925)
internal val Res.string.lesson_vocab_verbi_vari_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_verbi_vari_desc", "lesson_vocab_verbi_vari_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194067, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191419, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192730, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183739, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179763, 84),
      ))
    }

@delegate:ResourceContentHash(-385_079_100)
internal val Res.string.lesson_vocab_verbi_vari_title: StringResource by lazy {
      StringResource("string:lesson_vocab_verbi_vari_title", "lesson_vocab_verbi_vari_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194168, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191508, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192823, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183836, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179848, 73),
      ))
    }

@delegate:ResourceContentHash(-1_467_330_284)
internal val Res.string.lesson_vocab_verbs_1_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_verbs_1_desc", "lesson_vocab_verbs_1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194250, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191582, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 192897, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 183906, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179922, 93),
      ))
    }

@delegate:ResourceContentHash(949_185_194)
internal val Res.string.lesson_vocab_verbs_1_title: StringResource by lazy {
      StringResource("string:lesson_vocab_verbs_1_title", "lesson_vocab_verbs_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194348, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191692, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193015, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184016, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180016, 62),
      ))
    }

@delegate:ResourceContentHash(-249_438_040)
internal val Res.string.lesson_vocab_verbs_2_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_verbs_2_desc", "lesson_vocab_verbs_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194411, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191755, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193082, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184079, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180079, 101),
      ))
    }

@delegate:ResourceContentHash(1_389_951_128)
internal val Res.string.lesson_vocab_verbs_2_title: StringResource by lazy {
      StringResource("string:lesson_vocab_verbs_2_title", "lesson_vocab_verbs_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194537, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191861, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193200, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184193, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180181, 62),
      ))
    }

@delegate:ResourceContentHash(1_706_822_173)
internal val Res.string.lesson_vocab_verbs_3_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_verbs_3_desc", "lesson_vocab_verbs_3_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194600, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 191928, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193267, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184256, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180244, 89),
      ))
    }

@delegate:ResourceContentHash(-435_202_598)
internal val Res.string.lesson_vocab_verbs_3_title: StringResource by lazy {
      StringResource("string:lesson_vocab_verbs_3_title", "lesson_vocab_verbs_3_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194690, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192022, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193369, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184354, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180334, 62),
      ))
    }

@delegate:ResourceContentHash(-534_892_213)
internal val Res.string.lesson_vocab_verbs_4_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_verbs_4_desc", "lesson_vocab_verbs_4_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194757, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192089, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193436, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184421, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180397, 81),
      ))
    }

@delegate:ResourceContentHash(399_730_059)
internal val Res.string.lesson_vocab_verbs_4_title: StringResource by lazy {
      StringResource("string:lesson_vocab_verbs_4_title", "lesson_vocab_verbs_4_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194847, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192179, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193534, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184515, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180479, 62),
      ))
    }

@delegate:ResourceContentHash(563_185_717)
internal val Res.string.lesson_vocab_verbs_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_verbs_desc", "lesson_vocab_verbs_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 194910, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192246, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193601, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184578, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180542, 95),
      ))
    }

@delegate:ResourceContentHash(949_185_194)
internal val Res.string.lesson_vocab_verbs_title: StringResource by lazy {
      StringResource("string:lesson_vocab_verbs_title", "lesson_vocab_verbs_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195002, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192346, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193709, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184666, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180638, 60),
      ))
    }

@delegate:ResourceContentHash(-1_690_711_067)
internal val Res.string.lesson_vocab_vso_1_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_vso_1_desc", "lesson_vocab_vso_1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195063, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192407, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193774, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184727, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180699, 79),
      ))
    }

@delegate:ResourceContentHash(-1_483_973_050)
internal val Res.string.lesson_vocab_vso_1_title: StringResource by lazy {
      StringResource("string:lesson_vocab_vso_1_title", "lesson_vocab_vso_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195151, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192499, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193866, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184811, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180779, 60),
      ))
    }

@delegate:ResourceContentHash(-759_093_993)
internal val Res.string.lesson_vocab_vso_2_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_vso_2_desc", "lesson_vocab_vso_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195212, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192560, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193927, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184868, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180840, 83),
      ))
    }

@delegate:ResourceContentHash(-940_196_324)
internal val Res.string.lesson_vocab_vso_2_title: StringResource by lazy {
      StringResource("string:lesson_vocab_vso_2_title", "lesson_vocab_vso_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195308, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192656, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194031, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 184952, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180924, 60),
      ))
    }

@delegate:ResourceContentHash(1_356_867_590)
internal val Res.string.lesson_vocab_vso_3_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_vso_3_desc", "lesson_vocab_vso_3_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195377, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192721, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194096, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185013, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180985, 87),
      ))
    }

@delegate:ResourceContentHash(-1_639_056_622)
internal val Res.string.lesson_vocab_vso_3_title: StringResource by lazy {
      StringResource("string:lesson_vocab_vso_3_title", "lesson_vocab_vso_3_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195473, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192825, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194204, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185109, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181073, 56),
      ))
    }

@delegate:ResourceContentHash(-851_503_449)
internal val Res.string.lesson_vocab_vso_4_desc: StringResource by lazy {
      StringResource("string:lesson_vocab_vso_4_desc", "lesson_vocab_vso_4_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195530, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192882, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194261, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185162, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181130, 75),
      ))
    }

@delegate:ResourceContentHash(-1_254_363_355)
internal val Res.string.lesson_vocab_vso_4_title: StringResource by lazy {
      StringResource("string:lesson_vocab_vso_4_title", "lesson_vocab_vso_4_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195610, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192954, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194337, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185230, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181206, 44),
      ))
    }

@delegate:ResourceContentHash(-1_004_768_217)
internal val Res.string.levelup_accessory_unlocked_title: StringResource by lazy {
      StringResource("string:levelup_accessory_unlocked_title", "levelup_accessory_unlocked_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195663, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193003, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194386, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185283, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181251, 72),
      ))
    }

@delegate:ResourceContentHash(197_927_043)
internal val Res.string.levelup_feedback: StringResource by lazy {
      StringResource("string:levelup_feedback", "levelup_feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195748, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193088, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194467, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185360, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181324, 72),
      ))
    }

@delegate:ResourceContentHash(947_099_322)
internal val Res.string.levelup_streak_restoration_desc_many: StringResource by lazy {
      StringResource("string:levelup_streak_restoration_desc_many", "levelup_streak_restoration_desc_many", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 195821, 228),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193161, 200),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185437, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181397, 180),
      ))
    }

@delegate:ResourceContentHash(2_043_675_322)
internal val Res.string.levelup_streak_restoration_desc_one: StringResource by lazy {
      StringResource("string:levelup_streak_restoration_desc_one", "levelup_streak_restoration_desc_one", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196050, 167),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193362, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185634, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181578, 127),
      ))
    }

@delegate:ResourceContentHash(-1_668_691_185)
internal val Res.string.levelup_streak_restoration_title: StringResource by lazy {
      StringResource("string:levelup_streak_restoration_title", "levelup_streak_restoration_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196218, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193498, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185790, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181706, 80),
      ))
    }

@delegate:ResourceContentHash(1_579_165_342)
internal val Res.string.levelup_subtitle: StringResource by lazy {
      StringResource("string:levelup_subtitle", "levelup_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196315, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193591, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194532, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185871, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181787, 60),
      ))
    }

@delegate:ResourceContentHash(-505_882_949)
internal val Res.string.levelup_title: StringResource by lazy {
      StringResource("string:levelup_title", "levelup_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196376, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193652, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194597, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185936, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181848, 33),
      ))
    }

@delegate:ResourceContentHash(1_301_159_009)
internal val Res.string.loading_text: StringResource by lazy {
      StringResource("string:loading_text", "loading_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196426, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193702, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194647, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 185978, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181882, 36),
      ))
    }

@delegate:ResourceContentHash(1_119_388_718)
internal val Res.string.locked_icon_desc: StringResource by lazy {
      StringResource("string:locked_icon_desc", "locked_icon_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196467, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193739, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194688, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186019, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181919, 32),
      ))
    }

@delegate:ResourceContentHash(1_821_327_101)
internal val Res.string.login_btn: StringResource by lazy {
      StringResource("string:login_btn", "login_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196504, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193776, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194729, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186056, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181952, 25),
      ))
    }

@delegate:ResourceContentHash(-1_750_562_924)
internal val Res.string.login_with_google: StringResource by lazy {
      StringResource("string:login_with_google", "login_with_google", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196534, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193814, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194763, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186082, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181978, 53),
      ))
    }

@delegate:ResourceContentHash(-961_151_999)
internal val Res.string.logout_btn: StringResource by lazy {
      StringResource("string:logout_btn", "logout_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196588, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193876, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194821, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186132, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182032, 30),
      ))
    }

@delegate:ResourceContentHash(919_727_030)
internal val Res.string.mnemonic_association_hint: StringResource by lazy {
      StringResource("string:mnemonic_association_hint", "mnemonic_association_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196619, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 193915, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 194860, 173),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186159, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182063, 153),
      ))
    }

@delegate:ResourceContentHash(-1_652_682_275)
internal val Res.string.month_april: StringResource by lazy {
      StringResource("string:month_april", "month_april", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196797, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194085, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195034, 27),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186333, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182217, 27),
      ))
    }

@delegate:ResourceContentHash(1_549_668_951)
internal val Res.string.month_august: StringResource by lazy {
      StringResource("string:month_august", "month_august", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196825, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194113, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195062, 28),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186361, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182245, 28),
      ))
    }

@delegate:ResourceContentHash(-256_741_474)
internal val Res.string.month_december: StringResource by lazy {
      StringResource("string:month_december", "month_december", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196854, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194142, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195091, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186390, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182274, 34),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString18Resources(map: MutableMap<String, StringResource>) {
  map.put("lesson_ripasso_genere_numero_title", Res.string.lesson_ripasso_genere_numero_title)
  map.put("lesson_royal_names_desc", Res.string.lesson_royal_names_desc)
  map.put("lesson_royal_names_full_desc", Res.string.lesson_royal_names_full_desc)
  map.put("lesson_royal_names_full_title", Res.string.lesson_royal_names_full_title)
  map.put("lesson_royal_names_title", Res.string.lesson_royal_names_title)
  map.put("lesson_scorta_di_aggettivi_desc", Res.string.lesson_scorta_di_aggettivi_desc)
  map.put("lesson_scorta_di_aggettivi_title", Res.string.lesson_scorta_di_aggettivi_title)
  map.put("lesson_sdm_f_congiuntivo_desc", Res.string.lesson_sdm_f_congiuntivo_desc)
  map.put("lesson_sdm_f_congiuntivo_title", Res.string.lesson_sdm_f_congiuntivo_title)
  map.put("lesson_sdm_f_intro_desc", Res.string.lesson_sdm_f_intro_desc)
  map.put("lesson_sdm_f_intro_title", Res.string.lesson_sdm_f_intro_title)
  map.put("lesson_segni_degli_aggettivi_desc", Res.string.lesson_segni_degli_aggettivi_desc)
  map.put("lesson_segni_degli_aggettivi_title", Res.string.lesson_segni_degli_aggettivi_title)
  map.put("lesson_segni_vari_desc", Res.string.lesson_segni_vari_desc)
  map.put("lesson_segni_vari_title", Res.string.lesson_segni_vari_title)
  map.put("lesson_significato_dei_nomi_desc", Res.string.lesson_significato_dei_nomi_desc)
  map.put("lesson_significato_dei_nomi_title", Res.string.lesson_significato_dei_nomi_title)
  map.put("lesson_soggetto_esplicito_desc", Res.string.lesson_soggetto_esplicito_desc)
  map.put("lesson_soggetto_esplicito_title", Res.string.lesson_soggetto_esplicito_title)
  map.put("lesson_stars_earned_desc", Res.string.lesson_stars_earned_desc)
  map.put("lesson_torniamo_alla_grammatica_desc", Res.string.lesson_torniamo_alla_grammatica_desc)
  map.put("lesson_torniamo_alla_grammatica_title", Res.string.lesson_torniamo_alla_grammatica_title)
  map.put("lesson_traduciamo_i_nomi_desc", Res.string.lesson_traduciamo_i_nomi_desc)
  map.put("lesson_traduciamo_i_nomi_title", Res.string.lesson_traduciamo_i_nomi_title)
  map.put("lesson_transliteration_reading_desc", Res.string.lesson_transliteration_reading_desc)
  map.put("lesson_transliteration_reading_title", Res.string.lesson_transliteration_reading_title)
  map.put("lesson_tutto_insieme_ora_desc", Res.string.lesson_tutto_insieme_ora_desc)
  map.put("lesson_tutto_insieme_ora_title", Res.string.lesson_tutto_insieme_ora_title)
  map.put("lesson_un_attimo_desc", Res.string.lesson_un_attimo_desc)
  map.put("lesson_un_attimo_title", Res.string.lesson_un_attimo_title)
  map.put("lesson_un_seguace_eccellente_desc", Res.string.lesson_un_seguace_eccellente_desc)
  map.put("lesson_un_seguace_eccellente_title", Res.string.lesson_un_seguace_eccellente_title)
  map.put("lesson_una_definizione_desc", Res.string.lesson_una_definizione_desc)
  map.put("lesson_una_definizione_title", Res.string.lesson_una_definizione_title)
  map.put("lesson_uni_1_desc", Res.string.lesson_uni_1_desc)
  map.put("lesson_uni_1_title", Res.string.lesson_uni_1_title)
  map.put("lesson_uni_2_desc", Res.string.lesson_uni_2_desc)
  map.put("lesson_uni_2_title", Res.string.lesson_uni_2_title)
  map.put("lesson_verbi_e_participi_desc", Res.string.lesson_verbi_e_participi_desc)
  map.put("lesson_verbi_e_participi_title", Res.string.lesson_verbi_e_participi_title)
  map.put("lesson_verbi_intro_1_desc", Res.string.lesson_verbi_intro_1_desc)
  map.put("lesson_verbi_intro_1_title", Res.string.lesson_verbi_intro_1_title)
  map.put("lesson_verbi_sostantivati_desc", Res.string.lesson_verbi_sostantivati_desc)
  map.put("lesson_verbi_sostantivati_title", Res.string.lesson_verbi_sostantivati_title)
  map.put("lesson_vocab_animals_desc", Res.string.lesson_vocab_animals_desc)
  map.put("lesson_vocab_animals_title", Res.string.lesson_vocab_animals_title)
  map.put("lesson_vocab_dei_sovrani_desc", Res.string.lesson_vocab_dei_sovrani_desc)
  map.put("lesson_vocab_dei_sovrani_title", Res.string.lesson_vocab_dei_sovrani_title)
  map.put("lesson_vocab_famiglia_societa_desc", Res.string.lesson_vocab_famiglia_societa_desc)
  map.put("lesson_vocab_famiglia_societa_title", Res.string.lesson_vocab_famiglia_societa_title)
  map.put("lesson_vocab_food_desc", Res.string.lesson_vocab_food_desc)
  map.put("lesson_vocab_food_title", Res.string.lesson_vocab_food_title)
  map.put("lesson_vocab_humans_desc", Res.string.lesson_vocab_humans_desc)
  map.put("lesson_vocab_humans_title", Res.string.lesson_vocab_humans_title)
  map.put("lesson_vocab_oggetti_sacri_desc", Res.string.lesson_vocab_oggetti_sacri_desc)
  map.put("lesson_vocab_oggetti_sacri_title", Res.string.lesson_vocab_oggetti_sacri_title)
  map.put("lesson_vocab_pronomi_suffissi_desc", Res.string.lesson_vocab_pronomi_suffissi_desc)
  map.put("lesson_vocab_pronomi_suffissi_title", Res.string.lesson_vocab_pronomi_suffissi_title)
  map.put("lesson_vocab_vari_1_desc", Res.string.lesson_vocab_vari_1_desc)
  map.put("lesson_vocab_vari_1_title", Res.string.lesson_vocab_vari_1_title)
  map.put("lesson_vocab_vari_2_desc", Res.string.lesson_vocab_vari_2_desc)
  map.put("lesson_vocab_vari_2_title", Res.string.lesson_vocab_vari_2_title)
  map.put("lesson_vocab_varie_desc", Res.string.lesson_vocab_varie_desc)
  map.put("lesson_vocab_varie_title", Res.string.lesson_vocab_varie_title)
  map.put("lesson_vocab_verbi_vari_desc", Res.string.lesson_vocab_verbi_vari_desc)
  map.put("lesson_vocab_verbi_vari_title", Res.string.lesson_vocab_verbi_vari_title)
  map.put("lesson_vocab_verbs_1_desc", Res.string.lesson_vocab_verbs_1_desc)
  map.put("lesson_vocab_verbs_1_title", Res.string.lesson_vocab_verbs_1_title)
  map.put("lesson_vocab_verbs_2_desc", Res.string.lesson_vocab_verbs_2_desc)
  map.put("lesson_vocab_verbs_2_title", Res.string.lesson_vocab_verbs_2_title)
  map.put("lesson_vocab_verbs_3_desc", Res.string.lesson_vocab_verbs_3_desc)
  map.put("lesson_vocab_verbs_3_title", Res.string.lesson_vocab_verbs_3_title)
  map.put("lesson_vocab_verbs_4_desc", Res.string.lesson_vocab_verbs_4_desc)
  map.put("lesson_vocab_verbs_4_title", Res.string.lesson_vocab_verbs_4_title)
  map.put("lesson_vocab_verbs_desc", Res.string.lesson_vocab_verbs_desc)
  map.put("lesson_vocab_verbs_title", Res.string.lesson_vocab_verbs_title)
  map.put("lesson_vocab_vso_1_desc", Res.string.lesson_vocab_vso_1_desc)
  map.put("lesson_vocab_vso_1_title", Res.string.lesson_vocab_vso_1_title)
  map.put("lesson_vocab_vso_2_desc", Res.string.lesson_vocab_vso_2_desc)
  map.put("lesson_vocab_vso_2_title", Res.string.lesson_vocab_vso_2_title)
  map.put("lesson_vocab_vso_3_desc", Res.string.lesson_vocab_vso_3_desc)
  map.put("lesson_vocab_vso_3_title", Res.string.lesson_vocab_vso_3_title)
  map.put("lesson_vocab_vso_4_desc", Res.string.lesson_vocab_vso_4_desc)
  map.put("lesson_vocab_vso_4_title", Res.string.lesson_vocab_vso_4_title)
  map.put("levelup_accessory_unlocked_title", Res.string.levelup_accessory_unlocked_title)
  map.put("levelup_feedback", Res.string.levelup_feedback)
  map.put("levelup_streak_restoration_desc_many", Res.string.levelup_streak_restoration_desc_many)
  map.put("levelup_streak_restoration_desc_one", Res.string.levelup_streak_restoration_desc_one)
  map.put("levelup_streak_restoration_title", Res.string.levelup_streak_restoration_title)
  map.put("levelup_subtitle", Res.string.levelup_subtitle)
  map.put("levelup_title", Res.string.levelup_title)
  map.put("loading_text", Res.string.loading_text)
  map.put("locked_icon_desc", Res.string.locked_icon_desc)
  map.put("login_btn", Res.string.login_btn)
  map.put("login_with_google", Res.string.login_with_google)
  map.put("logout_btn", Res.string.logout_btn)
  map.put("mnemonic_association_hint", Res.string.mnemonic_association_hint)
  map.put("month_april", Res.string.month_april)
  map.put("month_august", Res.string.month_august)
  map.put("month_december", Res.string.month_december)
}
